import { setPatientDataCurrentCycle } from '../actions';
import axiosInstance from './axiosInstance';

import axios from 'axios';
export const createPatientApi = (payload) => {
  return axiosInstance
    .post('/patient/create-patient', payload)
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating user:', error);
      throw error;
    });
};

export const getUniquePatientIdApi = () => {
  return axiosInstance
    .get('/patient/unique-id')
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching unique patient ID:', error);
      throw error;
    });
};

// export const getAllPatientsApi = () => {
//   return axiosInstance
//     .get('/user/get-all-patients')
//     .then((response) => response)
//     .catch((error) => {
//       console.error('Error fetching all users:', error);
//       throw error;
//     });
// };

export const uploadPatientFileApi = async (
  file,
  patientId,
  patientSection = 'Other',
  updateFileStatusHandler,
  fileTag,
) => {
  try {
    const fileName = file.name;
    let fileExtension = '';

    try {
      fileExtension = fileName.split('.').pop();
    } catch (error) {}
    // Step 1: Get the presigned URL and file ID from the backend
    const response = await axiosInstance.post('/patient/upload', {
      size: file.size,
      fileType: file.type,
      fileExtension,
      fileName,
      contentType: file.type,
      patientId,
      patientSection: patientSection || 'Other',
      fileTag: fileTag || 'Other',
      fileTitle: 'Test',
    });
    const { url, fileId, id } = response.data;

    try {
      const response = await fetch(url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': file.type,
        },
      });

      if (response.ok) {
        if (updateFileStatusHandler) {
          const res = await updateFileStatusHandler(fileId);
          return res;
        }
      } else {
      }
    } catch (error) {
      throw error;
    }

    return {
      success: true,
      url: response.data.url,
      fileId: response.data.fileId,
    };
  } catch (error) {
    throw error;
  }
};

export const updateFileStatusUploaded = async (fileId) => {
  try {
    const response = await axiosInstance.post(
      '/patient/update-status-uploaded',
      {
        fileId,
      },
    );
    return response.data.fileData;
  } catch (error) {
    console.error('Error updating file status:', error);
    throw error;
  }
};

export const getAllPatientsApi = ({ page, pageSize }) => {
  return axiosInstance
    .get('/user/get-all-patients', {
      params: {
        page,
        pageSize,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching all users:', error);
      throw error;
    });
};

export const getAllSearchedPatients = ({
  page,
  pageSize,
  searchValue,
  searchByPatientId = false,
  searchByAadhaarNumber = false,
  searchByPhone = false,
  searchByName = false,
  searchByPartner = false,
}) => {
  return axiosInstance
    .get(`/user/get-all-patients/search`, {
      params: {
        page,
        pageSize,
        searchValue,
        searchByPatientId: searchByPatientId ? searchByPatientId : undefined,
        searchByAadhaarNumber: searchByAadhaarNumber
          ? searchByAadhaarNumber
          : undefined,
        searchByPhone: searchByPhone ? searchByPatientId : undefined,
        searchByName: searchByName ? searchByName : undefined,
        searchByPartner: searchByPartner ? searchByPartner : undefined,
      },
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching all users:', error);
      throw error;
    });
};
export const getPatientDetailsApi = (patientId) => {
  return axiosInstance
    .get(`patient/patient-details/${patientId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error fetching patient details:', error);
      throw error;
    });
};

export const updatePatientApi = (patientId, payload) => {
  return axiosInstance
    .put(`/patient/update/${patientId}`, payload)
    .then((response) => response)
    .catch((error) => {
      console.error('Error updating patient details:', error);
      throw error;
    });
};

export const deletePatientApi = (patientId) => {
  return axiosInstance
    .delete(`/patient/delete/${patientId}`)
    .then((response) => response)
    .catch((error) => {
      console.error('Error deleting patient:', error);
      throw error;
    });
};

export const createPatientPdfApi = (patientId) => {
  return axiosInstance
    .post(`/patient/create-pdf`, { patientId })
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating pdf:', error);
      throw error;
    });
};

export const createPatientHistoryPdfApi = (patientId) => {
  return axiosInstance
    .post(`/patient/create-patient-history-pdf`, { patientId })
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating pdf:', error);
      throw error;
    });
};

export const createPatientOPUPdfApi = (patientId, opuSheetData) => {
  return axiosInstance
    .post(`/patient/create-opu-sheet`, { patientId, opuSheetData })
    .then((response) => response)
    .catch((error) => {
      console.error('Error creating pdf:', error);
      throw error;
    });
};

export const checkFileAvailabilityApi = async (bucketName, key) => {
  try {
    const response = await axiosInstance.post(`/patient/file-available`, {
      bucketName,
      key,
    });
    return response.data;
  } catch (error) {
    console.error('Error checking file availability:', error);
    throw error;
  }
};

export const updatePatientProfileImageApi = async (patientId, fileId) => {
  try {
    const response = await axiosInstance.put(
      `/patient/update-profile-image/${patientId}`,
      {
        fileId,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error updating profile image:', error);
    throw error;
  }
};
export const updatePatientExaminationDetailsApi = async (
  patientId,
  payload,
) => {
  try {
    const response = await axiosInstance.patch(
      `/patient/update-examination-details`,
      {
        patientId,
        examinationDetails: payload,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error updating examination details:', error);
    throw error;
  }
};

// export const createPatientHistoryApi = async (patientId, payload) => {
//   try {
//     const response = await axiosInstance.post(
//       '/patient/create-patient-history',
//       {
//         patientId,
//         patientHistory: { ...payload },
//       },
//     );
//     return response.data;
//   } catch (error) {
//     console.error('Error creating patient history:', error);
//     throw error;
//   }
// };
export const updatePatientColumnApi = (patientId, updateDetails) => {
  return axiosInstance
    .patch(`/patient/update-patient/${patientId}`, {
      updateDetails,
    })
    .then((response) => response)
    .catch((error) => {
      console.error('Error updating patient column(s):', error);
      throw error;
    });
};

export const updatePatientInfertilityDetailsApi = (
  patientId,
  infertilityDetails,
) => {
  return axiosInstance
    .patch(`/patient/update-infertility/${patientId}`, infertilityDetails)
    .then((response) => response)
    .catch((error) => {
      console.error('Error updating patient infertility details:', error);
      throw error;
    });
};

export const updatePatientHistoryDetailsApi = (patientId, history) => {
  return axiosInstance
    .patch(`/patient/update-patient-history/${patientId}`, history)
    .then((response) => response)
    .catch((error) => {
      console.error('Error updating patient history details:', error);
      throw error;
    });
};

export const updatePatientTreatmentPlanApi = async (
  patientId,
  treatmentPlan,
) => {
  try {
    const response = await axiosInstance.patch(
      `/patient/update-treatment-plan`,
      {
        patientId,
        treatmentPlan,
      },
    );
    return response.data;
  } catch (error) {
    console.error('Error updating treatment plan:', error);
    throw error;
  }
};

export const createOrUpdateCycleApi = async (
  patientId,
  cycleId,
  fetSheet,
  fmsData,
  dispatch,
) => {
  try {
    const response = await axiosInstance.post(
      '/clinical/create-or-update-cycle',
      {
        patientId,
        cycleId,
        fetSheet,
        fmsData,
      },
    );
    dispatch(setPatientDataCurrentCycle(response.data.cycle));
    return response.data;
  } catch (error) {
    console.error('Error creating or updating cycle:', error);
    throw error;
  }
};

export const cancelCycleApi = async (cycleId) => {
  try {
    const response = await axiosInstance.post(`/clinical/cancel-cycle`, {
      cycleId,
    });
    return response.data;
  } catch (error) {
    console.error('Error cancelling cycle:', error);
    throw error;
  }
};

export const getLatestCycleApi = async (patientId) => {
  try {
    const response = await axiosInstance.get(
      `/clinical/latest-cycle/${patientId}`,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching latest cycle:', error);
    throw error;
  }
};

export const getAllCyclesApi = async (patientId) => {
  try {
    const response = await axiosInstance.get(
      `/clinical/all-cycles/${patientId}`,
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching all cycles:', error);
    throw error;
  }
};

export const getCyclesApi = async (page, pageSize) => {
  try {
    const response = await axiosInstance.get(`/clinical/get-all-cycles`, {
      params: {
        page,
        pageSize,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching cycles: ', error);
  }
};
